<template>
  <div class="flex items-start justify-start gap-3 min-h-[250px]">
    <SelectInput
      v-model:current-item="current_metric.aggregation_method"
      :value="current_metric.aggregation_method"
      name="aggregation_method"
      :items="metrics_aggregation_methods"
      :allow-null="!allowNull"
      label-attr="label"
      value-attr="value"
      :placeholder="$t('Roll-Up function')"
      :label="$t('Roll-Up function')"
      classes="w-3/12"
      input-classes="form-input" />
    <div v-if="current_metric.aggregation_method == 'weighted'" class="w-full">
      <div class="rounded-md bg-yellow-50 p-4">
        <div class="flex justify-between w-full items-center">
          <h3 class="text-md font-medium text-yellow-800">
            {{ $t("Example") }}
          </h3>
          <div class="flex-shrink-0">
            <Info class="h-10 w-10 text-yellow-800" aria-hidden="true" />
          </div>
        </div>
        <p class="text-yellow-800">
          {{ $t("% of Bookings Target formula is") }}:<br>
          <span class="!font-medium"> {{ $t("SUM(Actual Bookings) / SUM (Bookings Target)") }}</span>
        </p>
        <table class="table-auto w-full mt-5">
          <thead>
            <tr class="text-yellow-800 uppercase text-sm leading-normal">
              <th class="py-2 px-0 text-left">
                {{ $t("Company") }}
              </th>
              <th class="py-2 px-3 text-left">
                {{ $t("Actual Bookings") }}
              </th>
              <th class="py-2 px-3 text-left">
                {{ $t("Bookings Target") }}
              </th>
              <th class="py-2 px-0 text-left">
                {{ $t("% of Bookings Target") }}
              </th>
            </tr>
          </thead>
          <tbody class="text-gray-600 text-sm font-light">
            <tr class="border-b border-gray-200">
              <td class="py-3 px-1/2 text-left whitespace-nowrap">
                {{ $t("Company A") }}
              </td>
              <td class="py-3 px-1/2 text-center">
                {{ $t("10k") }}
              </td>
              <td class="py-3 px-1/2 text-center">
                {{ $t("20k") }}
              </td>
              <td class="py-3 px-1/2 text-center font-medium text-yellow-800">
                {{ $t("50%") }}
              </td>
            </tr>
            <tr class="border-b border-gray-200">
              <td class="py-3 px-1/2 text-left whitespace-nowrap">
                {{ $t("Company B") }}
              </td>
              <td class="py-3 px-1/2 text-center">
                {{ $t("0k") }}
              </td>
              <td class="py-3 px-1/2 text-center">
                {{ $t("10k") }}
              </td>
              <td class="py-3 px-1/2 text-center font-medium text-yellow-800">
                {{ $t("0%") }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="text-yellow-800">
              <td class="py-3 px-1/2 text-left font-medium" colspan="3">
                {{ $t("% of Bookings Target (weighted)") }}
              </td>
              <td class="py-3 px-1/2 text-left font-medium">
                {{ $t("33%") }}
              </td>
            </tr>
            <tr class="text-yellow-800">
              <td class="py-3 px-1/2 text-left font-medium" colspan="3">
                {{ $t("% of Bookings Target (non-weighted)") }}
              </td>
              <td class="py-3 px-1/2 text-left">
                {{ $t("25%") }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import SelectInput from "@/components/shared/SelectInput.vue"
import { utils } from "@/store/helpers"
import { Info } from "lucide-vue-next"

export default {
  components: {
    SelectInput,
    Info
  },
  props: {
    metric: {
      type: Object,
      required: true
    },
    allowNull: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "update"],
  data() {
    return {
      current_metric: null,
      metrics_aggregation_methods: [
        { label: this.$t("SUM"), value: "sum" },
        { label: this.$t("MAX"), value: "max" },
        { label: this.$t("MIN"), value: "min" },
        { label: this.$t("COUNT"), value: "count" },
        { label: this.$t("AVERAGE"), value: "average" },
        { label: this.$t("LAST VALUE"), value: "last_value" },
        { label: this.$t("MOST USED"), value: "most_used" },
        { label: this.$t("WEIGHTED"), value: "weighted" }
      ]
    }
  },
  watch: {
    current_metric: {
      deep: true,
      handler() {
        if (this.current_metric) {
          this.$emit("update", this.current_metric)
        }
      }
    }
  },
  created() {
    this.current_metric = utils.clone(this.metric)
  }
}
</script>
